<template>
  <div class="data">
    <router-link to="/editpersonal" class="tech_box flex_center">
      <img :src="tech.thumb?tech.thumb:tech.member_avatar" alt />
      <div class="tech_info">
        <p class="tech_name">{{tech.name}}</p>
        <p class="tech_level">等级: {{tech.level_title}} / {{tech.workingtime}}年经验</p>
      </div>
      <van-icon name="arrow" class="arrow" />
    </router-link>

    <div class="service_info">
      <router-link to="/editserviceinfo" class="service_label flex">
        服务信息
        <van-icon name="arrow" />
      </router-link>
      <ul>
        <li>
          <p class="service_title">服务项目</p>
          <div class="service_span">
            <span v-for="(item,index) in tech.tech_service" :key="index">{{item.title}}</span>
          </div>
        </li>
        <li>
          <p>
            服务时间 &nbsp;
            <span class="service_time">&nbsp;&nbsp;{{tech.working_starttime}}-{{tech.working_endtime}}</span>
          </p>
        </li>
        <!-- <li>
          <p class="service_title">技能标签</p>
          <div class="service_tip">
            <span>颈椎按摩</span>
            <span>腰部按摩</span>
          </div>
        </li> -->
      </ul>
    </div>

    <div class="service_info">
      <router-link to="/editworkinfo" class="service_label flex">
        从业信息<span class="iconfont icon-bianji"></span>
      </router-link>
      <ul>
        <li>
          <div class="work_info">
            <!-- <p>
              <span>安顺中医馆</span>
              <span>2009年-2015年</span>
            </p>
            <p>
              <span>安顺中医馆</span>
              <span>2015年-至今</span>
            </p> -->
            <p>
              {{tech.work_experience}}
            </p>
          </div>
        </li>
      </ul>
    </div>

    <div class="personal">
      <router-link to="/editpersonal" class="service_label flex">
        个人简介
        <span class="iconfont icon-bianji"></span>
      </router-link>

      <div class="personal_content">{{tech.desc}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "tech_data",
  components: {},
  data() {
    return {
      tech:[]
    };
  },
  created() {
    this.init();
  },
  methods: {
    init(){
      this.get_tech();
    },
    get_tech(){
      this.axios({
        url: this.api.tech.get_tech,
        data: {}
      }).then(res => {
        if (res.error === 0) {
          this.tech = res.tech;
          // that.technician_score = parseFloat(res.tech.score);
        }
      });
    }
  }
};
</script>
<style scoped>
.tech_box {
  padding: 0.75rem;
  background-color: white;
}
.tech_box img {
  width: 2.2rem;
  height: 2.2rem;
  border-radius: 50%;
  font-size: 0.75rem;
  color: #606262;
}
.tech_level {
  font-size: 0.6rem;
  color: #727273;
}
.tech_info {
  margin-left: 0.3rem;
}
.service_info {
  margin-top: 0.4rem;
  background-color: white;
  padding-bottom: 0.75rem;
}
.service_label {
  font-size: 0.75rem;
  color: #5a5a5b;
  padding: 0.75rem;
  border-bottom: 1px solid #eee;
}
.service_info ul {
  padding: 0.25rem 1.5rem;
  font-size: 0.6rem;
  color: #5a5a5b;
}
.service_info ul li {
  padding: 0.45rem 0;
}
.service_title {
  padding-bottom: 0.5rem;
}
.service_info span {
  font-size: 0.6rem;
  color: #727273 !important;
}
.service_time {
  color: #8f9092;
}
.service_tip span {
  padding: 0.1rem 0.35rem;
  color: #ec8b48 !important;
  background-color: #fbdec9;
  border-radius: 5px;
  margin-right: 0.3rem;
}
.work_info span {
  display: inline-block;
  width: 30%;
}
.work_info p {
  padding: .35rem 0 0;
}
.personal{
  margin-top:.4rem;
  background-color:white;
}
.personal_content{
  padding:.7rem 1.5rem;
  font-size:.6rem;
  color:#7D7E7E;
}
.service_span span{
  padding-right:.3rem;
}
.arrow{
  position:absolute;
  right:.75rem;
  font-size:.7rem;
}
</style>



// WEBPACK FOOTER //
// src/views/technician/perData/tech_data.vue